"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentProviders;
(function (PaymentProviders) {
    PaymentProviders["VISA_NET"] = "visanet";
    PaymentProviders["APEXX"] = "apexx";
    PaymentProviders["WEBPAY"] = "webpay";
})(PaymentProviders = exports.PaymentProviders || (exports.PaymentProviders = {}));
